import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {ConfirmPage} from "./pages/ConfirmPage.tsx";

export const SignUpLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={<IndexPage/>}
            />
            <Route
                path='confirm'
                element={<ConfirmPage/>}
            />
        </Routes>
    );
};
